window.addEventListener('load', function() {
    // Function to hide buttons
    var hideButtons = function() {
        // Hide buttons on the Small Solar Deployable Arrays product page
        var smallSolarButtons = document.querySelectorAll('.template-product-small-solar .add_to_cart_holder.add_to_cart_holder--multi .shopify-payment-button__button, .template-product-small-solar .add_to_cart_holder.add_to_cart_holder--multi #AddToCart');
        smallSolarButtons.forEach(function(button) {
            button.style.display = 'none';
        });

        // Hide buttons on the Large Solar Deployable Arrays product page
        var largeSolarButtons = document.querySelectorAll('.template-product-large-solar .add_to_cart_holder.add_to_cart_holder--multi .shopify-payment-button__button, .template-product-large-solar .add_to_cart_holder.add_to_cart_holder--multi #AddToCart');
        largeSolarButtons.forEach(function(button) {
            button.style.display = 'none';
        });
    };

    // Initially hide buttons
    hideButtons();
});
